import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TierFormPageRoutingModule } from './tier-form-routing.module';

import { TierFormPage } from './tier-form.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TierFormPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [TierFormPage]
})
export class TierFormPageModule {}
